import React, { useState } from "react";
import Swiper from "react-id-swiper";
import "swiper/css/swiper.css";
import "../../../assets/css/sliderBox.css";
// import "../../../assets/css/swiper.css";

const SliderBox = (props) => {
  const opusData = props.images;
  // console.log(opusData);
  // if (opusData.length > 1) {
  const [params] = useState({
    // navigation: {
    //   nextEl: ".swiper-button-next .swiper-button-white",
    //   prevEl: ".swiper-button-prev .swiper-button-white",
    // },
    // pagination: {
    //   el: ".swiper-pagination.swiper-pagination-white.swiper-pagination-position",
    //   type: "bullets",
    //   clickable: true,
    // },
    loop: false,
    centeredSlides: true,
    effect: "slide",
    spaceBetween: 50,
  });
  // } else {
  //   const [params] = useState({
  //     loop: false,
  //     centeredSlides: true,
  //     effect: "slide",
  //     spaceBetween: 50,
  //   });
  // }

  return (
    <div>
      <Swiper {...params}>
        {React.Children.toArray(
          opusData.map((images) => (
            <div>
              <img
                className="slider-img-fit"
                key={images}
                src={images.path}
                alt="作品画像"
                // onClick={() => dispatch(push("/opus/detail/" + images.id))}
              />
              <div className="spacer-box--s"></div>
            </div>
          ))
        )}
      </Swiper>
    </div>
  );
};

export default SliderBox;
